import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import AccessDenied from "./AccessDenied";

export default function ProtectedAdminRoute() {
  const { adminStatus } = useAuth();
  const location = useLocation();

  if (adminStatus === "loading") {
    return (
      <main className="auth-state-page">
        <section className="auth-state-panel">
          <p className="eyebrow">Admin only</p>
          <h1>Checking access</h1>
          <p>Verifying Firebase Auth and Chor admin authorization.</p>
        </section>
      </main>
    );
  }

  if (adminStatus === "signedOut") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (adminStatus === "denied") {
    return <AccessDenied />;
  }

  return <Outlet />;
}
